import State from '../core/State';
import initialState from '../initialState';
import produce, { Draft } from 'immer';
import SiteScript from '../entity/SiteScript';

export const startFetchingSiteScript = () =>
  produce((draft: Draft<State>) => {
    draft.siteScript.fetching = draft.siteScript.fetching + 1;
  });

export const setSiteScript = (siteScript: SiteScript) =>
  produce((draft: Draft<State>) => {
    draft.siteScript.data = siteScript;
  });

export const finishFetchingSiteScript = () =>
  produce((draft: Draft<State>) => {
    draft.siteScript.fetching = draft.siteScript.fetching - 1;
  });

export const disposeSiteScript = () =>
  produce((draft: Draft<State>) => {
    draft.siteScript.data = initialState.siteScript.data;
    draft.siteScript.fetching = initialState.siteScript.fetching;
  });
